// src/App.js
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Carousel.css';
import { Link } from 'react-router-dom';

const Carousel = () => {
    const settings = {
        // dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    // dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };


    const cardsData = [
        {
            title: '',
            content: 'عکس حاج قاسم حکم طلا داشت',
            class: 'c-card a1sgxeg568',
            link: "/khatereh/a1sgxeg568",
        },

        {
            title: '',
            content: 'از تلویزیون فهمیدیم',
            class: 'c-card a2zb5zbzbc',
            link: "/khatereh/a2zb5zbzbc",
        },

        {
            title: '',
            content: 'مرحم، مزارشهدا',
            class: 'c-card a3lkdbfmn6',
            link: "/khatereh/a3lkdbfmn6",
        },

        {
            title: '',
            content: 'گفت گاومیش هارا بگذارید و بروید',
            class: 'c-card a4ad3f5v2f',
            link: "/khatereh/a4ad3f5v2f",
        },

        {
            title: '',
            content: 'خون‌های یکی شده',
            class: 'c-card a5kvdbf5df',
            link: "/khatereh/a5kvdbf5df",
        },

        {
            title: '',
            content: 'دست در دست هم',
            class: 'c-card a6dbdb454f',
            link: "/khatereh/a6dbdb454f",
        }

    ];

    return (
        <div className="Carousell">

            <Slider {...settings}>
                {cardsData.map((card) => (
                    <Link to={card.link} className="c-card-container" >
                        <div className={card.class}>

                        </div>
                        <p className='c-card-title' style={{ color: '#152914', textDecoration: 'none', width: '90%', margin: 'auto' }}>{card.content}</p>
                    </Link>
                ))}


            </Slider>
        </div>
    );
}

export default Carousel;
